import { useAccidentsServiceAccidentsSportsList } from '@insurance/api/queries'
import { RadioCardGroup } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { useAccidentInsuranceValues } from './AccidentInsuranceContext'
import { formProps } from './utils'

export const SportRisk = () => {
  const { t, i18n } = useTranslation()
  const { required } = useValidationsField()
  const { sportRiskProps } = formProps(t)
  const { isEditable } = useAccidentInsuranceValues()

  const { data } = useAccidentsServiceAccidentsSportsList({}, [i18n.language])

  const options = data?.map(({ code, name, description }) => ({
    label: name,
    value: code,
    description,
    colProps: { xs: 24, lg: 8 }
  }))

  return (
    <Form.Item {...sportRiskProps} rules={[required]}>
      <RadioCardGroup options={options} disabled={isEditable} />
    </Form.Item>
  )
}
